import React from 'react'

function WorkforceManagementsec3() {

    const EngagementData = [
        {
            Head: "Seamless Integration with Your Existing Systems",
            Desc: "Workface integrates effortlessly with your current infrastructure. So whether your business relies on an existing ERP, HR management system, or payroll software, our platform enhances its capabilities, eliminating inefficiencies and ensuring a streamlined workflow."
        },
        {
            Head: "App for Effortless Scanning & Registrations",
            Desc: "Our intuitive mobile application simplifies employee registrations, remote attendance tracking, and workforce management. Employees can easily check in/out via a user-friendly scanning system, reducing manual input errors and improving operational accuracy."
        },
        {
            Head: "Comprehensive Business Automation",
            Desc: "From human resources to finance payouts, Workface automates tedious tasks, reducing administrative burdens and allowing your team to focus on strategic goals. Expense management, payroll processing, and vendor payments become smoother and more efficient, ensuring that financial transactions are both timely and accurate."
        },
        {
            Head: "Comprehensive Business Automation",
            Desc: "Track employee locations securely with our geolocation feature, ensuring accountability for remote teams. Whether managing field employees, remote staff, or distributed teams, Workface helps businesses verify work locations and ensure accurate attendance tracking—all within a secure and privacy-conscious system."
        },
        {
            Head: "Real-time Data & Insights",
            Desc: "Gain instant access to real-time analytics on employee performance, attendance, and financial operations. With dynamic dashboards and reporting, businesses can make informed decisions backed by accurate, up-to-the-minute data."
        },
        {
            Head: "Scalability for Future Growth",
            Desc: "As your business grows, so does Workface. Our solution is highly scalable, ensuring that whether you’re a small business or an enterprise-level organization, our system adapts to your needs."
        }
    ]

  return (
    <section className='engage-sec' style={{marginBottom: "0"}}>
        <div className='container'>
            <h3>How Do We Stand Out?</h3>
            <ul>
                {
                  EngagementData.map((Engagement, index)=>(
                    <li key={index} style={{marginBottom: "20px"}}>
                        <h4>{Engagement.Head}</h4>
                        <p>{Engagement.Desc}</p>
                    </li>   
                  ))  
                }
            </ul>
        </div>
    </section>
  )
}

export default WorkforceManagementsec3
